let $ = require("jquery");
let _ = require("underscore");
let DbRecorder = require("../recorder/DbRecorder.js");
import i18n from "../utils/i18n";
import POS from "../POS.js";
let Backbone = require("backbone");

let main = function(){
    var status = new Backbone.Model({status:"Create"});
    var PurchaseLicenseService = {
        getStatus:function(){
            return status;
        },
        chargeSuccess:function(payload){
            console.log("payload="+payload);
            if(payload.status == "Paid"){
                status.set({status:"Paid",paid:"true"},{silent:true});
                status.trigger("Paid");
            }
        }
    };
    return PurchaseLicenseService;
};
let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/service/PurchaseLicenseService.js